<template>
  <div>
    <the-hero-section :title="title" :imgLink="imgLink" />
    <vertical-divider />
    <section id="service" class="extra-padding grey lighten-4">
      <v-container class="">
        <v-row justify="center" align="center">
          <v-col cols="12">
            <h1 class="text-h2 text-uppercase text-center primary--text">
              servicios
            </h1>
            <v-divider
              class="pt-1 mx-auto my-2 secondary"
              width="50"
            ></v-divider>
            <p
              class="primary--text text-body-1 text-center my-5 font-weight-light"
            >
              En Argecam buscamos la satisfacción de todos nuestros clientes,
              por esta razón, buscamos la mejora continua en cada uno de los
              trabajos que realizamos; gracias a esto, apuntamos a la excelencia
              en los servicios brindados.
            </p>
          </v-col>
          <v-col cols="12">
            <v-row justify="center" align="center">
              <v-col v-for="s in servicios" :key="s.i" cols="10" sm="6" md="4">
                <v-card
                  class="rounded-lg grey lighten-4 mx-auto elevation-0"
                  width="300"
                >
                  <div class="text-center">
                    <v-avatar
                      class="mx-5 mt-5"
                      color="grey lighten-4"
                      size="60"
                      height="60"
                      width="auto"
                      tile
                    >
                      <img
                        :alt="s.title"
                        :src="require('@/assets/servicios-argecam/' + s.img)"
                        class="shad"
                      />
                    </v-avatar>
                  </div>

                  <v-card-title class="mt-0 primary--text">
                    <div class="mx-auto">
                      <h1 class="title">{{ s.title }}</h1>
                    </div>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "Service",
  components: {
    TheHeroSection: () => import("@/components/TheHeroSection"),
    //ServiceCard: () => import("@/components/ServiceCard.vue"),
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue")
  },
  data: () => ({
    title: "Nuestros Servicios",
    imgLink: "section-obras.jpeg",
    servicios: [
      {
        title: "Excavaciones",
        img: "excavaciones.png"
      },
      {
        title: "Demoliciones",
        img: "demoliciones.png"
      },
      {
        title: "Movimiento de suelos",
        img: "movimiento-suelos.png"
      },
      {
        title: "Provisión de Áridos",
        img: "provision-aridos.png"
      },
      {
        title: "Alquiler de equipos viales",
        img: "alquiler-equipos-viales.png"
      },
      {
        title: "Alquiler de Camiones",
        img: "alquiler-camiones.png"
      }
    ]
  })
};
</script>
<style lang="sass" scoped>
.shad
  filter: drop-shadow(1px 3px 1px #000000)
</style>
